import { useState } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { NavTabs } from '@components/NavTabs';
import { useTranslation } from '@hooks';
import { RoutePath } from '@constants/routes';
import ReplyTemplates from './ReplyTemplates';
import AutoReplies from './AutoReplies';

const Container = styled('div')({
    '@media (max-width: 1024px)': {
        padding: 16,
        height: 'calc(var(--100vh) - 108px)',
        overflowY: 'auto',
    },
});

const ReplyAutomation = () => {
    const { pathname } = useLocation();
    const [currentTab, setCurrentTab] = useState(pathname);
    const { t } = useTranslation();

    const availableTabs = [
        { label: t('Sidebar.reviewsAutoreplies'), value: RoutePath.ReviewsAutomationAutoReplies },
        { label: t('Sidebar.reviewsTemplates'), value: RoutePath.ReviewsAutomationTemplates },
    ];

    const RouteMap = {
        [RoutePath.ReviewsAutomationAutoReplies]: 0,
        [RoutePath.ReviewsAutomationTemplates]: 1,
    };

    return (
        <Container>
            <NavTabs
                tabLinks={availableTabs}
                onTabClick={selectedTab => setCurrentTab(selectedTab)}
                currentTabIndex={RouteMap[currentTab]}
            />
            <Switch>
                <Route path={RoutePath.ReviewsAutomationTemplates} component={ReplyTemplates} />
                <Route path={RoutePath.ReviewsAutomationAutoReplies} component={AutoReplies} />
                <Redirect from={RoutePath.ReviewsAutomation} to={RoutePath.ReviewsAutomationAutoReplies} />
            </Switch>
        </Container>
    );
};

export default ReplyAutomation;
